import { invoke } from '@shared/easyfy.decorators';
import { element } from '../../../../../Easyfy.Commerce/Easyfy.Commerce.Presentation/ClientApp/shared/scripts/easyfy.core';

@invoke
export class BreadCrumb {
  static Instance: BreadCrumb;
  private breadCrumbs: HTMLElement = element('.breadcrumbs');
  private breadCrumbBlurbox: HTMLElement = element('.breadcrumb-blurbox-container');

  onInit() {
    BreadCrumb.Instance.breadCrumbs?.addEventListener('scrollend', this.handleScrollEvent);
  }

  private handleScrollEvent() {
    const scrollLocation = Math.round(BreadCrumb.Instance.breadCrumbs.scrollLeft);
    const scrollDiff = BreadCrumb.Instance.breadCrumbs.clientWidth - BreadCrumb.Instance.breadCrumbs.scrollWidth;

    if (0 <= scrollLocation - scrollDiff && scrollLocation - scrollDiff <= 1) {
      BreadCrumb.Instance.breadCrumbBlurbox.style.setProperty('--show-left-blur', 'none');
    } else {
      BreadCrumb.Instance.breadCrumbBlurbox.style.setProperty('--show-left-blur', 'block');
    }
  }
}
